<style lang="less" scoped>
.detail-form-parent-div .flex {
  flex-wrap: wrap;
}

.detail-from-input {
  box-sizing: border-box;
  width: auto;
  flex: 1 1 300px;
  min-width: 0;
  max-width: 450px;
  margin: 10px 30px;
}

.detail-form-parent-div .flex .detail-from-input {
  flex: 1 1 300px;
  min-width: 0;
  max-width: 450px;
}

.detail-body-title {
  font-size: 15px;
  font-weight: 600;
  margin: 16px 31px 10px;
}

.margin-bt-10 {
  margin-bottom: 24px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumbList"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="formModel" :rules="mergedRules" ref="embedForm" class="detail-form">
          <div class="detail-form-parent-div margin-bt-10">
            <el-form-item class="detail-from-input" label="嵌入式版本号" prop="softVersion">
              <el-input
                v-model="formModel.softVersion"
                @input="onSoftVersionInput"
                :disabled="isReadonly || mode !== 'add'"
                clearable
                size="small"
                placeholder="请输入嵌入式版本号"
                maxlength="200"
              ></el-input>
            </el-form-item>
            <div class="detail-body-title">默认嵌入式版本功能</div>
            <!-- 三列排布与原型一致 -->
            <div class="flex">
              <el-form-item class="detail-from-input" label="预约充电" prop="hasReservation">
                <el-select class="full-width" size="small" v-model="formModel.hasReservation" clearable
                  :disabled="isReadonly" placeholder="请选择预约充电">
                  <el-option label="有" :value="1"></el-option>
                  <el-option label="无" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="即插即充" prop="offHandChargingFlag">
                <el-select class="full-width" size="small" v-model="formModel.offHandChargingFlag" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="有" value="Y"></el-option>
                  <el-option label="无" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="无感充电" prop="cardFlag">
                <el-select class="full-width" size="small" v-model="formModel.cardFlag" clearable :disabled="isReadonly"
                  placeholder="请选择">
                  <el-option label="有" value="Y"></el-option>
                  <el-option label="无" value="N"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="音频" prop="audioType">
                <el-select ref="audioType" @change="changeSelect('audioType')" class="full-width" size="small"
                  v-model="formModel.audioType" clearable :disabled="isReadonly" placeholder="请选择">
                  <el-option label="无" value="00"></el-option>
                  <el-option label="蜂鸣器" value="01"></el-option>
                  <el-option label="扬声器" value="02"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="联网方式" prop="networkStatus">
                <el-select ref="networkStatus" @change="changeSelect('networkStatus')" class="full-width" size="small"
                  v-model="formModel.networkStatus" clearable :disabled="isReadonly" placeholder="请选择">
                  <el-option label="4G" value="01"></el-option>
                  <el-option label="4G+WIFI" value="02"></el-option>
                  <el-option label="无" value="03"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="蓝牙功能" prop="bluetoothFlag">
                <el-select class="full-width" size="small" v-model="formModel.bluetoothFlag" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="有" value="Y"></el-option>
                  <el-option label="无" value="N"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="蓝牙配置" prop="bluetoothPairFlag">
                <el-select class="full-width" size="small" v-model="formModel.bluetoothPairFlag" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="新协议" value="Y"></el-option>
                  <el-option label="老协议" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="蚂蚁森林能量发放" prop="isGreenEnergy">
                <el-select class="full-width" size="small" v-model="formModel.isGreenEnergy" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="可以" value="Y"></el-option>
                  <el-option label="不可以" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="是否支持智能充电" prop="adjustPower">
                <el-select class="full-width" size="small" v-model="formModel.adjustPower" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                  <el-option label="OTA升级支持" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="是否参与活动" prop="isActivity">
                <el-select class="full-width" size="small" v-model="formModel.isActivity" clearable
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="参加" value="Y"></el-option>
                  <el-option label="不参加" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="是否带屏桩" prop="isScreen">
                <el-select class="full-width" size="small" v-model="formModel.isScreen" clearable :disabled="isReadonly"
                  placeholder="请选择">
                  <el-option label="全部支持" value="1"></el-option>
                  <el-option label="不支持" value="2"></el-option>
                  <el-option label="休眠方式设置" value="3"></el-option>
                  <el-option label="显示模式设置" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="电流调节" prop="hasCurrentAdjustable">
                <el-select class="full-width" size="small" v-model="formModel.hasCurrentAdjustable" clearable
                  :disabled="isReadonly" placeholder="请选择电流调节">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="亲友共享" prop="hasFamilySharing">
                <el-select class="full-width" size="small" v-model="formModel.hasFamilySharing" clearable
                  :disabled="isReadonly" placeholder="请选择亲友共享">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="充电闹钟" prop="hasChargingAlarm">
                <el-select class="full-width" size="small" v-model="formModel.hasChargingAlarm" clearable
                  :disabled="isReadonly" placeholder="请选择充电闹钟">
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="设备升级" prop="upgradeMethod">
                <el-select class="full-width" size="small" v-model="formModel.upgradeMethod" clearable
                  :disabled="isReadonly" placeholder="请选择设备升级">
                  <el-option label="在线+离线升级" :value="3"></el-option>
                  <el-option label="离线升级" :value="2"></el-option>
                  <el-option label="在线升级" :value="1"></el-option>
                  <el-option label="不支持升级" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="国际兼容设置" prop="hasNationalStandardCompatibility">
                <el-select class="full-width" size="small" v-model="formModel.hasNationalStandardCompatibility"
                  clearable :disabled="isReadonly" placeholder="请选择国际兼容设置">
                  <el-option label="无" :value="0" />
                  <el-option label="二极管" :value="1" />
                  <el-option label="cp" :value="2" />
                  <el-option label="全部" :value="99" />
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="参与活动类型" prop="activityType">
                <el-select class="full-width" size="small" v-model="formModel.activityType" clearable
                  :disabled="isReadonly" placeholder="请选择参与活动类型">
                  <el-option label="不参与活动" :value="0"></el-option>
                  <el-option label="订阅活动" :value="2"></el-option>
                  <el-option label="桩主联盟活动" :value="1"></el-option>
                  <el-option label="家庭充电超级服务包" :value="3"></el-option>
                  <el-option label="送桩活动" :value="4"></el-option>
                  <el-option label="安心包活动" :value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="是否支持刷卡" prop="hasCardSwipingSupported">
                <el-select class="full-width" size="small" v-model="formModel.hasCardSwipingSupported" clearable
                  :disabled="isReadonly" placeholder="请选择是否支持刷卡">
                  <el-option label="支持" :value="1"></el-option>
                  <el-option label="不支持" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="私桩共享" prop="hasPrivatePileSharing">
                <el-select class="full-width" size="small" v-model="formModel.hasPrivatePileSharing" clearable
                  :disabled="isReadonly" placeholder="请选择私桩共享">
                  <el-option label="有" :value="1"></el-option>
                  <el-option label="无" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="是否支持三插头温控" prop="hasThreePinThermalControl">
                <el-select class="full-width" size="small" v-model="formModel.hasThreePinThermalControl"
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="不支持" :value="0"></el-option>
                  <el-option label="支持" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="是否支持转换头识别" prop="adapterRecognition">
                <el-select class="full-width" size="small" v-model="formModel.adapterRecognition" :disabled="isReadonly"
                  placeholder="请选择">
                  <el-option label="不支持" :value="0"></el-option>
                  <el-option label="支持" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex">
              <el-form-item class="detail-from-input" label="倒计时预约" prop="countdownReservation">
                <el-select class="full-width" size="small" v-model="formModel.countdownReservation"
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="不支持" :value="0"></el-option>
                  <el-option label="支持" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="detail-from-input" label="电流设置记忆" prop="currentSettingMemory">
                <el-select class="full-width" size="small" v-model="formModel.currentSettingMemory"
                  :disabled="isReadonly" placeholder="请选择">
                  <el-option label="不支持" :value="0"></el-option>
                  <el-option label="支持" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <template v-if="!isReadonly">
          <button class="common-bg-button" :disabled="submitting" @click="submitForm">提 交</button>
          <button class="common-empty-button" :disabled="submitting" @click="goBack">取 消</button>
        </template>
        <button v-else class="common-bg-button" @click="goBack">返 回</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config/config';
import pageConfig, { validateEmbeddedSoftVersionPrefix } from './page-config';
import {
  buildOnlyAddPileFunctionBody,
  mergeEmbeddedDeviceFormOntoEntity,
} from './pile-function-payload';

function storageKey(pileTypeNo) {
  return 'chargingPile_embedded_list_' + (pileTypeNo || '__new__');
}

function parentDetailStorageKey(pileTypeNo) {
  return 'chargingPile_parent_detail_' + (pileTypeNo || '__new__');
}

/** findByFunctionId / 父页快照中的集合字段，不写入表单 model */
const ENTITY_LIST_KEYS = new Set(['pileTypeVersionEntityList', 'otherEmbeddedVersionList']);

function emptyFunctionModel() {
  return {
    softVersion: '',
    // 不在本页展示，仅用于保留“是否为默认版本”的值
    defaultFlag: 0,
    status: 0,
    createdWhen: '',
    pileTypeVersionId: '',
    pileFunctionId: '',
    pileTypeNo: '',
    isDel: 'N',
    createdByName: '',
    lastModifiedByName: '',
    lastModifiedWhen: '',
    hasReservation: '',
    offHandChargingFlag: '',
    cardFlag: '',
    audioType: '',
    audioTypeName: '',
    networkStatus: '',
    networkStatusName: '',
    bluetoothFlag: '',
    bluetoothPairFlag: '',
    isGreenEnergy: '',
    isActivity: '',
    adjustPower: '',
    isScreen: null,
    hasCurrentAdjustable: '',
    hasFamilySharing: '',
    hasChargingAlarm: '',
    upgradeMethod: '',
    hasNationalStandardCompatibility: '',
    activityType: '',
    hasCardSwipingSupported: '',
    hasPrivatePileSharing: '',
    hasThreePinThermalControl: 0,
    adapterRecognition: 0,
    countdownReservation: 0,
    currentSettingMemory: 0,
  };
}

/** 与主表 findPileFunctionByNo 的 to01 一致：统一为 0/1，匹配 el-select 的 :value 数字 */
function to01Field(val) {
  if (val === null || val === undefined || val === '' || val === 'null') return 0;
  const n = Number(val);
  return n === 1 ? 1 : 0;
}

export default {
  data() {
    const validateSoftVersionCharset = (rule, value, callback) => {
      const s = value != null ? String(value) : '';
      if (!s) {
        callback();
        return;
      }
      // 仅允许 ASCII 字符，拦截中文、表情等 Unicode 字符
      if (/[^\x00-\x7F]/.test(s)) {
        callback(new Error('嵌入式版本号不支持中文或表情'));
        return;
      } 
      callback();
    };
    const embeddedRules = {
      softVersion: [
        { required: true, message: '请输入嵌入式版本号', trigger: 'blur' },
        { validator: validateEmbeddedSoftVersionPrefix, trigger: 'blur' },
        { validator: validateSoftVersionCharset, trigger: ['blur', 'change'] },
      ],
    };
    const embedFormRules = { ...pageConfig.formRules };
    delete embedFormRules.status;
    return {
      pageConfig,
      submitting: false,
      lastValidSoftVersion: '',
      mode: 'add',
      rowIndex: -1,
      formModel: emptyFunctionModel(),
      mergedRules: { ...embedFormRules, ...embeddedRules },
      breadCrumbList: [
        { type: 'title', name: '首页' },
        { type: 'title', name: '系统配置' },  
        { type: 'router', name: '充电桩基础信息管理', router: 'ChargingPile' },
        { type: 'title', name: '其他嵌入式版本' },
      ],
    };
  },
  computed: {
    pageTitle() {
      if (this.mode === 'add') return '新增其他嵌入式版本';
      return '编辑其他嵌入式版本';
    },
    /** 表格「详情」与编辑共用可编辑页，不再使用只读详情态 */
    isReadonly() {
      return false;
    },
  },
  methods: {
    onSoftVersionInput(val) {
      const raw = val != null ? String(val) : '';
      if (/[^\x00-\x7F]/.test(raw)) {
        this.$U.error('嵌入式版本号不支持中文或表情');
        this.formModel.softVersion = this.lastValidSoftVersion;
        return;
      }
      this.lastValidSoftVersion = raw;
    },
    fetchDetailByFunctionId(functionId, pileTypeVersionId) {
      if (!functionId) return Promise.resolve(null);
      this.submitting = true;
      return this.$H
        .post(this, this.$A.digitization.findByFunctionId, { functionId })
        .then((res) => {
          if (res.status !== 200) return null;
          const data = res.data && res.data.data ? res.data.data : null;
          if (!data) {
            this.$U.error('未获取到详情数据');
            return null;
          }
          const entity = data;

          // 将 findByFunctionId 根级字段全部带入表单（仅排除嵌套列表），保证 onlyAddPileFunction 可原样回传 materialNo 等
          const next = emptyFunctionModel();
          Object.keys(entity).forEach((k) => {
            if (ENTITY_LIST_KEYS.has(k)) return;
            if (entity[k] !== undefined) next[k] = entity[k];
          });

          // 版本元数据仅从接口 pileTypeVersionEntityList 解析（不靠本地缓存行）
          const list = Array.isArray(entity.pileTypeVersionEntityList) ? entity.pileTypeVersionEntityList : [];
          let vRow = pileTypeVersionId
            ? list.find((r) => String(r.pileTypeVersionId || '') === String(pileTypeVersionId))
            : null;
          const fnStr = functionId != null ? String(functionId) : '';
          if (!vRow && fnStr && list.length) {
            vRow = list.find(
              (r) =>
                String(r.pileFunctionId || '') === fnStr || String(r.functionId || '') === fnStr
            );
          }
          const picked = vRow || {};
          next.softVersion = picked.softVersion != null ? String(picked.softVersion) : (entity.softVersion || '');
          next.defaultFlag = picked.defaultFlag === 1 || picked.defaultFlag === '1' ? 1 : 0;
          next.status = picked.status === 1 || picked.status === '1' ? 1 : 0;
          next.createdWhen = picked.createdWhen || entity.createdWhen || '';
          next.pileTypeVersionId = picked.pileTypeVersionId || '';
          // 查询入参 functionId 即本行 pileFunctionId；优先于子表 picked，避免仍用主档 entity.functionId
          const reqFn =
            functionId != null && String(functionId).trim() !== '' ? String(functionId) : '';
          const routeRowPileFn =
            this.$route.query.pileFunctionId != null && String(this.$route.query.pileFunctionId).trim() !== ''
              ? String(this.$route.query.pileFunctionId)
              : '';
          next.pileFunctionId =
            reqFn || picked.pileFunctionId || routeRowPileFn || entity.functionId || '';
          next.pileTypeNo = picked.pileTypeNo || entity.pileTypeNo || '';
          next.isDel = picked.isDel || 'N';
          next.createdByName = picked.createdByName || entity.createdByName || '';
          next.lastModifiedByName = picked.lastModifiedByName || entity.lastModifiedByName || '';
          next.lastModifiedWhen = picked.lastModifiedWhen || entity.lastModifiedWhen || '';

          // 下拉框部分字段保持字符串表现
          if (next.adjustPower !== undefined && next.adjustPower !== null && next.adjustPower !== '') {
            next.adjustPower = next.adjustPower + '';
          }
          if (next.isScreen !== undefined && next.isScreen !== null && next.isScreen !== '') {
            next.isScreen = next.isScreen + '';
          }

          next.countdownReservation = to01Field(next.countdownReservation);
          next.currentSettingMemory = to01Field(next.currentSettingMemory);

          this.formModel = next;
          this.lastValidSoftVersion = this.formModel.softVersion || '';
          this.$nextTick(() => {
            if (this.$refs.embedForm) this.$refs.embedForm.clearValidate();
          });
          return entity;
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    changeSelect(val) {
      this.$nextTick(() => {
        const ref = this.$refs[val];
        if (ref && ref.selected) {
          this.formModel[val] = ref.selected.value;
          this.formModel[`${val}Name`] = ref.selected.label;
        }
      });
    },
    readList() {
      const pileTypeNo = this.$route.query.pileTypeNo || '';
      const raw = sessionStorage.getItem(storageKey(pileTypeNo));
      if (!raw) return [];
      try {
        const list = JSON.parse(raw);
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    },
    writeList(list) {
      const pileTypeNo = this.$route.query.pileTypeNo || '';
      sessionStorage.setItem(storageKey(pileTypeNo), JSON.stringify(list));
    },
    readParentDetail(pileTypeNo) {
      const raw = sessionStorage.getItem(parentDetailStorageKey(pileTypeNo));
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },
    /**
     * 请求体由 pile-function-payload 生成：mainPileFunction、piletypeEntity、根级 pileTypeVersionEntityList、subPileFunction
     */
    normalizeListForStorage(list) {
      if (!Array.isArray(list)) return [];
      return list.map((row) => ({
        ...row,
        status: row.status === 1 || row.status === '1' ? 1 : 0,
        defaultFlag: row.defaultFlag === 1 || row.defaultFlag === '1' ? 1 : 0,
      }));
    },
    initForm() {
      this.mode = this.$route.query.mode || 'add';
      const idx = this.$route.query.index;
      this.rowIndex = idx === undefined || idx === '' ? -1 : parseInt(idx, 10);
      const pileTypeNo = this.$route.query.pileTypeNo || '';
      const parent = this.readParentDetail(pileTypeNo);

      // 编辑/详情：只认接口 findByFunctionId，不用父页 session、不用本地 embedded 列表拼凑
      if (this.mode !== 'add') {
        const apiFunctionId =
          (this.$route.query.functionId && String(this.$route.query.functionId)) ||
          (this.$route.query.pileFunctionId && String(this.$route.query.pileFunctionId)) ||
          '';
        if (!apiFunctionId) {
          this.$U.error('缺少版本标识，请从列表重新进入');
          this.formModel = emptyFunctionModel();
          return;
        }
        this.formModel = emptyFunctionModel();
        this.fetchDetailByFunctionId(apiFunctionId, this.$route.query.pileTypeVersionId);
        return;
      }

      // 仅新增：从父页「充电桩基础信息详情」快照预填设备功能字段
      let base = emptyFunctionModel();
      if (parent) {
        Object.keys(parent).forEach((k) => {
          if (ENTITY_LIST_KEYS.has(k)) return;
          if (parent[k] !== undefined) base[k] = parent[k];
        });
      }

      if (base.adjustPower !== undefined && base.adjustPower !== null && base.adjustPower !== '') {
        base.adjustPower = base.adjustPower + '';
      }
      if (base.isScreen !== undefined && base.isScreen !== null && base.isScreen !== '') {
        base.isScreen = base.isScreen + '';
      }
      base.countdownReservation = to01Field(base.countdownReservation);
      base.currentSettingMemory = to01Field(base.currentSettingMemory);
      this.formModel = base;
      this.lastValidSoftVersion = this.formModel.softVersion || '';
      this.$nextTick(() => {
        if (this.$refs.embedForm) this.$refs.embedForm.clearValidate();
      });
    },
    submitForm() {
      if (this.submitting) return;
      this.$refs.embedForm.validate((valid) => {
        if (!valid) {
          this.$U.error('请完善表单信息！');
          return;
        }
        const pileTypeNo = this.$route.query.pileTypeNo || '';
        const parent = this.readParentDetail(pileTypeNo);
        const list = this.readList();
        const routeNo = this.$route.query.pileTypeNo || '';
        const isEdit = this.mode === 'edit';

        if (isEdit && this.rowIndex < 0) {
          this.$U.error('数据异常，请返回重试');
          return;
        }

        const routeRowFn =
          (this.$route.query.pileFunctionId && String(this.$route.query.pileFunctionId)) ||
          (this.$route.query.functionId && String(this.$route.query.functionId)) ||
          '';
        const formForPayload = {
          ...this.formModel,
          pileFunctionId: this.formModel.pileFunctionId || routeRowFn,
        };
        if (isEdit && !formForPayload.pileFunctionId) {
          this.$U.error('缺少该版本 pileFunctionId，无法提交');
          return;
        }

        const { body, versionList } = buildOnlyAddPileFunctionBody(
          parent || {},
          formForPayload,
          list,
          routeNo,
          isEdit ? 'edit' : 'add',
          isEdit ? this.rowIndex : -1
        );
        let nextList = this.normalizeListForStorage(versionList);
        if (isEdit && this.rowIndex >= 0 && nextList[this.rowIndex]) {
          mergeEmbeddedDeviceFormOntoEntity(nextList[this.rowIndex], this.formModel);
        } else if (!isEdit && nextList.length > 0) {
          mergeEmbeddedDeviceFormOntoEntity(nextList[nextList.length - 1], this.formModel);
        }
        this.writeList(nextList);
        this.submitting = true;
        axios
          .post(this.$A.digitization.onlyAddPileFunction, body, {
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              authorization: this.$store.state.token,
            },
            timeout: config.httpTimeOut,
          })
          .then((res) => {
            if (!res || res.status !== 200) {
              this.$U.error((res && res.data && res.data.message) || '保存失败，请重试');
              return;
            }
            this.$U.success('保存成功');
            this.navigateBack();
          })
          .catch((err) => {
            const msg =
              (err && err.response && err.response.data &&
                (err.response.data.message || err.response.data.msg)) ||
              (err && err.message) ||
              '保存失败，请重试';
            this.$U.error(msg);
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    navigateBack() {
      const pileTypeNo = this.$route.query.pileTypeNo;
      const q = {};
      if (pileTypeNo) q.pileTypeNo = pileTypeNo;
      q.fromEmbedded = '1';
      this.$router.push({
        name: 'ChargingPileDetail',
        query: q,
      });
    },
    goBack() {
      this.navigateBack();
    },
  },
  mounted() {
    this.initForm();
  },
  watch: {
    '$route.query': {
      handler() {
        this.initForm();
      },
      deep: true,
    },
  },
};
</script>
